import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
// Pages
import Home from "./pages/Landing/Home";
import Footer from "./components/Footer";
import WebDevelopment from "./pages/WebDevelopment";
import MobileApp from "./pages/MobileAppDevelopment";
import MernStack from "./pages/MernStack";
import SoftwareCompany from "./pages/SoftwareCompanyIndia";
import Internship from "./pages/Internship";
import UIUX from "./pages/UIUXDesign";
import Ecommerce from "./pages/Ecommerce";
import CustomSoftware from "./pages/CustomSoftware";
import Cloud from "./pages/Cloud";
import AI from "./pages/AIDevelopment";
import { ServiceSection } from "./pages/Services/ServiceSection";

export const App = () => {
  return (
    <div className="min-h-screen">

      {/* Navigation */}
      <Navbar />

      {/* Website Pages */}
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServiceSection />} />



        <Route path="/web-development-company" element={<WebDevelopment />} />
        <Route path="/mobile-app-development" element={<MobileApp />} />
        <Route path="/mern-stack-development" element={<MernStack />} />
        <Route path="/software-company-india" element={<SoftwareCompany />} />
        <Route path="/internship-training" element={<Internship />} />
        <Route path="/ui-ux-design" element={<UIUX />} />
        <Route path="/ecommerce-development" element={<Ecommerce />} />
        <Route path="/custom-software" element={<CustomSoftware />} />
        <Route path="/cloud-solutions" element={<Cloud />} />
        <Route path="/ai-development" element={<AI />} />



      </Routes>

      <Footer />

    </div>
  );
};

